// extracted by mini-css-extract-plugin
export default {"ProgressCircleContainer":"📚19-10-2q_sgS","ProgressCircle":"📚19-10-2_PKqO","ProgressBackground":"📚19-10-2MMTSj","Progress":"📚19-10-2__fx0","IconContainer":"📚19-10-2TZWe9"};